<template>
  <custom-dialog
    width="1100px"
    :title="title"
    class="device-test-dialog"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body" ref="print">
      <div class="device-header">
        <h2>
          {{ testType === '1' ? $t('dms_device_reportDetail_dialog.dccsbg') : $t('dms_device_reportDetail_dialog.zjcsbg') }}
        </h2>
        <ul class="info">
          <li class="param fail" v-if="info.reportState === 0">
            <i class="icon icon-close-circle-fill"></i>
            {{ $t('dms_device_reportDetail_dialog.ce_shi_bu_tong_guo') }}
          </li>
          <li class="param pass" v-if="info.reportState === 1">
            <i class="icon icon-yanzhengtongguo"></i>
            {{ $t('dms_device_reportDetail_dialog.ce_shi_tong_guo') }}
          </li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_shi_jian') }}：{{ momentAmPm($momentLocal(info.gmtCreate)) }}</li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_shi_wen') }}：{{ $celsiusToFahrenheit(info.envTemp) }}{{ $formatTempUnit() }}</li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_ren') }}:{{ info.creator }}</li>
          <li class="param">{{ 'Modem SN' }}：{{ modemSn }}</li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.sjgxsj') }}：{{ momentAmPm($momentLocal(info.lastDataUpdateTime)) }}</li>
        </ul>
      </div>
      <div class="table-bd">
        <!--         style="overflow-y: auto;" -->
        <custom-table
          :data="tableList"
          :column="tableColumn"
          :index="true"
          :border="true"
          :span-method="objectSpanMethod"
          :slots="['isNormal', 'langCode', 'moduleLangCode', 'value', 'unit']"
          height="100%"
        >
          <template v-slot:moduleLangCode="scope">{{ compLanguageMap[scope.row.moduleLangCode] }}</template>
          <template v-slot:langCode="scope">{{ tslDataLanguageMap[scope.row.langCode] }}</template>
          <template v-slot:isNormal="scope">
            <div v-if="`${scope.row.isNormal}` !== '0'">
              {{ isynergy_common_normal_num[`${scope.row.isNormal}`] }}
            </div>
            <div v-else class="fail">
              {{ isynergy_common_normal_num[`${scope.row.isNormal}`] }}
            </div>
          </template>
          <template v-slot:value="scope">
            <template v-if="scope.row.dicGroup && scope.row.dicGroup !== '-' && scope.row.value !== 'null'">
              {{ getDicValue(scope.row.dicGroup, scope.row.value) }}
            </template>
            <template v-else-if="scope.row.unit === '℃'">
              {{ $celsiusToFahrenheit(scope.row.value) }}
            </template>
            <template v-else>
              {{ scope.row.value }}
            </template>
          </template>
          <template v-slot:unit="scope">
            {{ scope.row.unit === '℃' ? $formatTempUnit() : getDicValue('iot_tsl_data_unit', scope.row.unit, 'value') }}
          </template>
        </custom-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onPrint">{{ $t('dms_device_reportDetail_dialog.da_yin') }}</el-button>
      <el-button type="primary" @click="exportPdf">{{ $t('dms_device_reportDetail_dialog.dao_chupdf') }}</el-button>
    </div>
    <div class="pdf-dom" id="pdfDom" ref="pdfDom" style="overflow: hidden; margin-top: 100px; padding: 24px">
      <div class="device-header">
        <p>{{ title }}</p>
        <h2>
          {{ testType === '1' ? $t('dms_device_reportDetail_dialog.dccsbg') : $t('dms_device_reportDetail_dialog.zjcsbg') }}
        </h2>
        <ul class="info">
          <li class="param fail" v-if="info.reportState === 0">
            <i class="icon icon-close-circle-fill"></i>
            {{ $t('dms_device_reportDetail_dialog.ce_shi_bu_tong_guo') }}
          </li>
          <li class="param pass" v-if="info.reportState === 1">
            <i class="icon icon-yanzhengtongguo"></i>
            {{ $t('dms_device_reportDetail_dialog.ce_shi_tong_guo') }}
          </li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_shi_jian') }}：{{ momentAmPm($momentLocal(info.gmtCreate)) }}</li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_shi_wen') }}：{{ $celsiusToFahrenheit(info.envTemp) }}{{ $formatTempUnit() }}</li>

          <li class="param">{{ $t('dms_device_reportDetail_dialog.ce_shi_ren') }}:{{ info.creator }}</li>
          <li class="param">{{ 'Modem SN' }}：{{ modemSn }}</li>
          <li class="param">{{ $t('dms_device_reportDetail_dialog.sjgxsj') }}：{{ momentAmPm($momentLocal(info.lastDataUpdateTime)) }}</li>
        </ul>
      </div>
      <div class="table-bd" style="height: auto">
        <!--         style="overflow-y: auto;" -->
        <custom-table :data="tableList" :column="tableColumn" :index="true" :border="true" :span-method="objectSpanMethod" :slots="['isNormal', 'langCode', 'moduleLangCode', 'value']">
          <template v-slot:moduleLangCode="scope">{{ compLanguageMap[scope.row.moduleLangCode] }}</template>
          <template v-slot:langCode="scope">{{ tslDataLanguageMap[scope.row.langCode] }}</template>
          <template v-slot:isNormal="scope">
            <div v-if="`${scope.row.isNormal}` !== '0'">
              {{ isynergy_common_normal_num[`${scope.row.isNormal}`] }}
            </div>
            <div v-else class="fail">
              {{ isynergy_common_normal_num[`${scope.row.isNormal}`] }}
            </div>
          </template>
          <template v-slot:value="scope">
            <template v-if="scope.row.dicGroup && scope.row.dicGroup !== '-' && scope.row.value !== 'null'">
              {{ getDicValue(scope.row.dicGroup, scope.row.value) }}
            </template>
            <template v-else>
              {{ scope.row.value }}
            </template>
          </template>
        </custom-table>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
// import contract_logistics_recordVue from '../../crm/contractDetail/children/contract_logistics_record.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false
    // },
    productCode: [String, Number],
    modemSn: [String, Number],
    batteryId: [String, Number],
    testReportId: [String, Number],
    testType: [String], // 测试类型:1-电池，9-整机
  },
  // watch: {
  //   visible: {
  //     immediate: true,
  //     handler(val) {
  //       this.selfVisible = val;
  //     }
  //   }
  // },
  data() {
    return {
      tableCode: 'devicedetail_test_report',
      // tableCode: 'device_test_report',
      // selfVisible: false,
      temp: 0,
      col: [],
      data: [],
      tableList: [],
      col1Config: {},
      col2Config: {},
      info: {
        reportData: [],
        envTemp: '',
        reportState: 0,
        gmtCreate: '',
        creator: '',
        batterySn: '',
      },
      compLanguageMap: {},
      tslDataLanguageMap: {},

      isynergy_common_normal_num: {},
    };
  },
  computed: {
    title() {
      const bodyNum = this.info.bodyNum ? `–SN:${this.info.bodyNum}` : '';
      const batterySn = this.info.batterySn ? `–SN:${this.info.batterySn}` : '';
      return this.testType === '1' ? this.$t('dms_device_reportDetail_dialog.dccsbgo', [batterySn]) : this.$t('dms_device_reportDetail_dialog.zjcsbgo', [bodyNum]);
    },
  },
  mounted() {
    this.getTableColumn();
    this.getDictionary('device_test_report_header,isynergy_common_normal_num', (data) => {
      this.isynergy_common_normal_num = this.$transformDicValue(data.isynergy_common_normal_num);
      const col = data.device_test_report_header.map((item) => ({
        columnCode: item.value,
        columnName: item.name,
        selected: true,
      }));

      // is_normal name转结果
      col.forEach((item) => {
        if (item.columnCode === 'is_normal') {
          item.columnName = this.$t('dms_device_reportDetail_dialog.jie_guo');
        }
      });
      this.col = col;
      this.init();
    });
  },
  methods: {
    init() {
      this.visible = true;
      this.$getJSON(`${apis.DeviceTestReportInfo}/${this.testReportId}`).then((res) => {
        this.info = res.data;
        // this.data = JSON.parse(res.data.reportData);
        // this.tableList = this.$treeToList(this.data, this.col);

        this.tableList = JSON.parse(res.data.reportData);
        // 字典值转name
        // this.tableList.forEach((item) => {

        //   if (item.dicGroup && item.dicGroup !== '' && item.value !== 'null') {
        //     const val = this.getDicValue(item.dicGroup, item.value);
        //     item.value = val;
        //   }
        // });
        this.nullValueToCrossbar(this.tableList, ['isNormal', 'value']);
        // this.tableList.forEach((obj) => {
        //   Object.keys(obj).forEach((key) => {
        //     if (!obj[key] || obj[key] === 'null') {
        //       obj[key] = '-';
        //     }
        //   });
        // });
        this.getLanguageMap();
        this.getCol1Config();
      });
    },
    getCol1Val(key) {
      return this.col1Map[key] || key;
    },
    getCol2Val(key) {
      return this.col2Map[key] || key;
    },
    // 初始化合并单元格配置
    getCol1Config() {
      const list = this.$splitArrByKey(this.tableList, 'moduleLangCode');
      const ret = {};
      let index = 0;
      list.forEach((arr) => {
        const len = arr.length;
        ret[index] = len;
        index += len;
      });
      this.col1Config = ret;
    },
    onNormalChange(val, index) {
      const len = this.col1Config[index];
      for (let i = index; i < index + len; i++) {
        this.tableList[i].isNormal = val;
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if ([1, 2, 6].includes(columnIndex)) {
        if (this.col1Config[rowIndex]) {
          return {
            rowspan: this.col1Config[rowIndex],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    // 获取测试模块和测试项目的多语言
    // 特殊表格列多语言翻译
    getLanguageMap() {
      // 产品部件（测试模块）
      this.$getJSON(apis.LanguagePlatform, {
        keyGroupCode: 'iot_component_lang',
      }).then((res) => {
        this.compLanguageMap = res.data;
      });
      // 物模型数据（测试项目）
      this.$getJSON(apis.LanguagePlatform, {
        keyGroupCode: 'iot_tsl_data_lang',
      }).then((res) => {
        this.tslDataLanguageMap = res.data;
      });
    },
    // 导出pdf
    exportPdf: function () {
      this.$exportPdf('#pdfDom', this.title);
    },
    // 打印
    onPrint() {
      // this.$print(this.$refs.print);
      this.$onPrint('.pdf-dom');
    },
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.device-test-dialog {
  .el-dialog__body {
    height: calc(100% - 106px);
  }
  .el-dialog {
    margin: auto !important;
    height: 100%;
    overflow: hidden;
  }
  .device-header {
    p {
      height: 20px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      line-height: 20px;
      margin-bottom: 20px;
    }
    h2 {
      height: 40px;
      font-size: 28px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      line-height: 40px;
      margin-bottom: 40px;
      text-align: center;
    }
    .info {
      display: flex;
      justify-content: center;
      padding-bottom: 30px;
      .param {
        margin-right: 28px;
        height: 17px;
        font-size: 12px;
        color: rgba(73, 80, 87, 1);
        line-height: 17px;
        .icon {
          font-size: 12px;
          margin-right: 5px;
        }
      }
      .pass {
        color: #0d9ae0;
      }
      .fail {
        color: #ff5c5b;
      }
    }
  }

  .dialog-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .table-bd {
    margin-top: 16px;
    flex: 1;
    overflow-y: auto;
  }
  .fail {
    color: #ff5c5b;
  }
  .el-dialog__footer {
    border-top: 1px solid #e9ebec;
    padding-top: 11px;
    padding-bottom: 11px;
  }
}
@media print {
  // 去掉页眉 页尾
  @page {
    size: auto; /* auto is the initial value */
    margin: 3mm; /* this affects the margin in the printer settings */
  }

  html {
    background-color: #ffffff;
    margin: 0px; /* this affects the margin on the html before sending to printer */
  }

  body {
    // border: solid 1px blue ;
    margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
  }

  // 打印样式
  h2 {
    height: 40px;
    font-size: 28px;
    font-weight: bold;
    color: rgba(57, 70, 104, 1);
    line-height: 40px;
    margin-bottom: 40px;
    text-align: center;
  }
  .info {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
    .param {
      margin-right: 15px;
      height: 17px;
      font-size: 12px;
      color: rgba(73, 80, 87, 1);
      line-height: 17px;
      .icon {
        font-size: 12px;
        margin-right: 5px;
      }
    }
    .pass {
      color: #0d9ae0;
    }
    .fail {
      color: #ff5c5b;
    }
  }
  .fail {
    color: #ff5c5b;
  }
}
</style>
